export const SET_SHARED_BROWSER_STATE = 'SET_SHARED_BROWSER_STATE';
export const RESET_SHARED_BROWSER_STATE = 'RESET_SHARED_BROWSER_STATE';
export const TOGGLE_SHARED_BROWSER = 'TOGGLE_SHARED_BROWSER';
